import { Model } from '@vuex-orm/core';
import Image from '@/models/Image';

export default class ImageSize extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'imagesSizes';

  // List of all fields (schema) of the imagesize model.
  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      url: this.attr(null),
      width: this.attr(null),
      height: this.attr(null),

      /*thumbnail: this.attr(null),
      medium: this.attr(null),
      medium_large: this.attr(null),
      large: this.attr(null),*/

      // relationship IDs
      image_id: this.attr(null),

      // relationships
      image: this.belongsTo(Image, 'image_id'),
    };
  }
}
